import { Markdown } from "../components/Markdown";
import { demands, demandsIntro, divestTitleParts, petitionLabel, petitionUrl } from "../content";
import "../styles/page.css";

function DetroitDivest() {
  return (
    <main id="main-content" tabIndex={-1} className="page">
      {/* Light masthead: the demand bands below are dark, so this hands off to a
          contrasting ground instead of merging into one slab. */}
      <header className="page__masthead page__masthead--light">
        <div className="page__masthead-inner">
          <h1 className="page__title">
            {divestTitleParts.before}
            <span className="page__title-accent">{divestTitleParts.highlight}</span>
            {divestTitleParts.after}
          </h1>
          <p className="page__lede">
            <Markdown animateNumbers>{demandsIntro}</Markdown>
          </p>
          <div className="page__masthead-actions">
            <a
              className="page__cta"
              href={petitionUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`${petitionLabel} (opens in new tab)`}
            >
              {petitionLabel}
            </a>
          </div>
        </div>
      </header>

      <ol className="bands">
        {demands.map((demand) => (
          <li key={demand.number} className="band">
            <div className="band__inner">
              <div className="band__lead">
                <span className="band__num" aria-hidden="true">
                  {demand.number}
                </span>
                <h2 className="band__title">{demand.title}</h2>
              </div>
              <div>
                <p className="band__body">
                  <Markdown>{demand.body}</Markdown>
                </p>
                {demand.faqs.map((faq) => (
                  <div key={faq.q} className="band__faq">
                    <p className="band__q">{faq.q}</p>
                    <p className="band__a">
                      <Markdown>{faq.a}</Markdown>
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </li>
        ))}
      </ol>
    </main>
  );
}

export default DetroitDivest;
